import { Button, Tooltip } from "@fluentui/react-components";
import { StopCircleOutlined } from "@mui/icons-material";
import i18next from "i18next";
import { cancelChatApiRequestProcessingOnServerSide } from "../../api";
import { QuestionInputReducerAction } from "../../Store/QuestionInputReducer";
import { useDispatch, useSelector } from "react-redux";
import { selectAnswerGenerationActive, selectRequestedToForceStop } from "../../Store";
import React from "react";
import styles from "./ChatAPIResponseGenerationAbortButton.module.css";
import { RootState } from "../../Store";

const ChatAPIResponseGenerationAbortButton = () => {
    const dispatch = useDispatch();
    const answerGenerationActive = useSelector(selectAnswerGenerationActive);
    const requestedToForceStopAIResponseGeneration = useSelector(selectRequestedToForceStop);
    const answerGenerationActiveDetails = useSelector((state: RootState) => state.questionInput.answerGenerationActiveDetails);

    return (
        <>
            {answerGenerationActive && !requestedToForceStopAIResponseGeneration && (
                <Tooltip
                    content={{
                        children: i18next.t("questionInput.AIResponseGenerationStopButton"),
                        style: {
                            backgroundColor: "white"
                        }
                    }}
                    relationship="label"
                >
                    <Button
                        id="responseGenerationStopButton"
                        className={styles.responseGenerationStopBtn}
                        size="large"
                        icon={
                            <StopCircleOutlined
                                sx={{
                                    color: "white",
                                    backgroundColor: "#6a6ee6",
                                    borderRadius: "50%",
                                    width: "44px",
                                    height: "44px"
                                }}
                            />
                        }
                        style={{
                            height: "50px",
                            width: "50px",
                            minWidth: "50px",
                            padding: 0
                        }}
                        onClick={() => {
                            cancelChatApiRequestProcessingOnServerSide({
                                edited_question_id: answerGenerationActiveDetails.editedQuestionId,
                                is_edit_request: answerGenerationActiveDetails.isEditedQuestion,
                                is_chat_shared: answerGenerationActiveDetails.isChatShared,
                                sessionId: answerGenerationActiveDetails.sessionId
                            });
                            dispatch(QuestionInputReducerAction.updateForceStopAIResponseGeneration(true));
                        }}
                    />
                </Tooltip>
            )}
        </>
    );
};

export default ChatAPIResponseGenerationAbortButton;
